/* eslint-disable no-underscore-dangle */
class BfvDropdown {
  constructor(options = {}) {
    this.$root = options.element;
    this.$select = this.$root.querySelector('select');
    this.persistId = this.$root.getAttribute('data-persist-id');
    this.localStoragePersistId = `Dropdown-Value-${this.$root.getAttribute('data-persist-id')}`;
    this.localStorage = window.localStorage;
  }

  init() {
    if (!this.persistId) {
      return;
    }
    const selectOptionsArray = Array.prototype.slice.call(this.$select.options);
    const storedValue = this.localStorage[this.localStoragePersistId];
    if (storedValue) {
      if (selectOptionsArray.find((option) => option.value === storedValue)) {
        this.$select.value = storedValue;
      }
    } else {
      // check if some option has a preselection from the BE and store that Value
      const beSelectedOption = selectOptionsArray.find((option) => option.selected);
      if (beSelectedOption) {
        this.$select.value = beSelectedOption.value;
        this.localStorage[this.localStoragePersistId] = beSelectedOption.value;
      }
    }
    this.__bindEvents();
  }

  __bindEvents() {
    this.$select.addEventListener('change', (event) => this.__storeValue(event.target.value));
  }

  __storeValue(value) {
    this.localStorage[this.localStoragePersistId] = value;
  }
}

export default BfvDropdown;
